import { Flex, Modal, Text, ThemeIcon } from '@mantine/core';
import React from 'react';
import { IconAlertTriangle, IconExclamationCircle } from '@tabler/icons-react';

type Props = {
  opened: boolean;
  message?: string | null;
  onClose: () => void;
};

export function GenericErrorModal({ opened, onClose: handleClose, message }: Props) {
  return (
    <GenericIconModal
      opened={opened}
      onClose={handleClose}
      message={message}
      Icon={IconExclamationCircle}
      color="red"
    />
  );
}

export function GenericWarningModal({ opened, onClose: handleClose, message }: Props) {
  return (
    <GenericIconModal
      opened={opened}
      onClose={handleClose}
      message={message}
      Icon={IconAlertTriangle}
      color="yellow"
    />
  );
}

function GenericIconModal({
  opened,
  onClose: handleClose,
  message,
  Icon,
  color = 'blue',
}: Props & { Icon: React.ElementType; color?: string }) {
  return (
    <>
      <Modal size={'lg'} opened={opened} onClose={handleClose}>
        <Flex flex={1} align={'center'} direction={'column'}>
          <ThemeIcon variant="light" radius="xl" size="xl" color={color}>
            <Icon style={{ width: '70%', height: '70%' }} />
          </ThemeIcon>
          <Text ta={'center'} my={'xl'} fw={'500'} style={{ whiteSpace: 'pre-wrap' }}>
            {message}
          </Text>
        </Flex>
      </Modal>
    </>
  );
}
